"use strict";

(function () {
  var app = new Vue({
    el: '#app',
    data: function data() {
      return {
        order_id: this.$utils.query('order_id', null),
        goods_buy_area: 19,
        h5url: '',
        banner: [],
        goods: [],
        data: {},
        page: 1,
        size: 20,
        nore: false,
        list: [],
        cat_id: 0,
        listl: [],
        listr: [],
        alert_notice: {},
        alertshow: false,
        noticelist: [],
        notnum: 0,
        is_first_leader: 1,
        pageshow: false,
        times: 0,
        timetype: 0,
        service_mobile: '',
        tabs: [],
        isalert: 0,
        shop_community: {},
        is_shop_community: false,
        ad_list: [],
        showAd: false,
        home_goods_deputy_buy_area: ''
      };
    },
    created: function created() {
      this.$utils.backRefreshInit(); //接受刷新
      // this.$utils.backRefresh(); //返回上页刷新

      localStorage.removeItem('goshopdetailurls'); //清除分享

      localStorage.removeItem('goshopdetaildata'); //清除分享

      window.sessionStorage.removeItem('cat_id');
      window.sessionStorage.removeItem('shopType');
      this.datas();
    },
    mounted: function mounted() {// this.lists()
    },
    methods: {
      searchs: function searchs(id) {
        this.cat_id = id;
        this.page = 1;
        this.listl = [];
        this.listr = [];
        this.nore = false; // window.onscroll = this.winbottom

        document.getElementById('lslistm').style.minHeight = '1500px';
        this.lists();
      },
      escalert: function escalert() {
        this.alertshow = false;
        localStorage.setItem('stalert' + this.alert_notice.id, '1');
      },
      datas: function datas() {
        var _this = this;

        this.$http.get('/api/home/main', {}).then(function (res) {
          _this.data = res.data; //限制首页商品展示最大数量

          _this.data.barter_goods_list = _this.data.barter_goods_list.slice(0, 2); //易货好商品

          _this.data.coin_goods_list = _this.data.coin_goods_list.slice(0, 2); //优惠购大牌

          _this.data.active_goods_list = _this.data.active_goods_list.slice(0, 4); //购买商品即刻获取大量消费积分
          //限制首页商品展示最大数量end

          _this.banner = res.data.ad_list;
          _this.alert_notice = res.data.alert_notice;
          _this.shop_community = res.data.shop_community;
          _this.isalert = res.data.shop_community_status;
          _this.is_shop_community = Object.keys(res.data.shop_community).length === 0 ? false : true;
          var stalert = localStorage.getItem('stalert' + _this.alert_notice.id) || '';

          if (stalert == '' && !!_this.alert_notice.content) {
            _this.alertshow = true;
          }

          _this.service_mobile = res.data.service_mobile;
          _this.is_first_leader = localStorage.getItem('is_first_leader') || 1;
          _this.pageshow = true;
          _this.goods_buy_area = res.data.home_goods_buy_area;
          _this.home_goods_deputy_buy_area = res.data.home_goods_deputy_buy_area; // })

          _this.$http.get('/api/home/init_info', {}).then(function (res) {
            _this.h5url = res.data.contact.im_url;
          });

          _this.$http.get('/api/goods/get_goods_cat', {
            params: {
              goods_buy_area: _this.goods_buy_area,
              goods_deputy_buy_area: _this.home_goods_deputy_buy_area,
              is_home: 1
            }
          }).then(function (res) {
            _this.tabs = res.data;
          });

          _this.$http.get('/api/home/ad_list', {
            params: {}
          }).then(function (res) {
            // this.noticelist=res.data
            _this.ad_list = res.data;

            if (res.data.ad_1 && res.data.ad_1.list && res.data.ad_1.list.length > 0) {
              _this.showAd = true;
            } else if (res.data.ad_2 && res.data.ad_2.list && res.data.ad_2.list.length > 0) {
              _this.showAd = true;
            } else if (res.data.ad_3 && res.data.ad_3.list && res.data.ad_3.list.length > 0) {
              _this.showAd = true;
            } else {
              _this.showAd = false;
            }
          });

          _this.lists();
        });
      },
      lists: function lists() {
        var _this2 = this;

        if (this.nore) {
          window.onscroll = null;
          vant.Toast({
            message: '没有更多了',
            position: 'bottom'
          });
          return;
        }

        this.$utils.loading(); //开起加载

        this.$http.get('/api/goods/get_area_goods_list', {
          params: {
            cat_id: this.cat_id,
            goods_buy_area: this.goods_buy_area,
            goods_deputy_buy_area: this.home_goods_deputy_buy_area,
            page: this.page,
            size: this.size,
            is_home: 1
          }
        }).then(function (res) {
          _this2.$utils.loadingClear(); //关闭加载


          if (res.data.length == 0 && _this2.page == 1) {
            window.onscroll = null;
            return;
          }

          if (res.data.length < _this2.size) _this2.nore = true;

          if (res.data.length == 0) {
            window.onscroll = null;
            vant.Toast({
              message: '没有更多了',
              position: 'bottom'
            });
            return;
          } else {
            _this2.page++;
            window.onscroll = _this2.winbottom;
          }

          var i = 0;
          var stimelis = setInterval(function () {
            _this2.$utils.loadingClear(); //关闭加载


            if (i == res.data.length) {
              clearInterval(stimelis);
              document.getElementById('lslistm').style.minHeight = '0px';
              return;
            }

            var lslistl = document.getElementById('lslistl').clientHeight;
            var lslistr = document.getElementById('lslistr').clientHeight;

            if (_this2.listl.length > _this2.listr.length && lslistl == 0) {
              _this2.listr.push(res.data[i]);

              return;
            }

            if (lslistl <= lslistr) {
              _this2.listl.push(res.data[i]);
            } else {
              _this2.listr.push(res.data[i]);
            }

            i++;
          }, 100);
        });
      },
      winbottom: function winbottom() {
        var _this3 = this;

        var clients = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
        var stop = document.documentElement.scrollTop || document.body.scrollTop;
        var sheigt = document.documentElement.scrollHeight;

        if (clients + stop >= sheigt - 10) {
          window.onscroll = null;
          setTimeout(function () {
            _this3.lists();
          }, 500);
        }
      },
      issign: function issign(url) {
        if (!!localStorage.removeItem("cityorderid")) {
          localStorage.removeItem("citydata");
          localStorage.removeItem("cityorderid");
        }

        if (localStorage.getItem('earch_token') != null) {
          window.location.href = url;
        } else {
          window.location.href = '../sign/sign.html';
        }
      },
      issignType: function issignType(type, id, type_id) {
        if (!!localStorage.removeItem("cityorderid")) {
          localStorage.removeItem("citydata");
          localStorage.removeItem("cityorderid");
        }

        if (localStorage.getItem('earch_token') != null) {
          // window.location.href = url
          if (type == 1) {
            window.location.href = '../shopfive/shop.html?goods_buy_area=' + id + "&goods_deputy_buy_area=" + type_id;
          } else if (type == 2) {
            window.location.href = '../newshop/shopyh.html?goods_buy_area=' + id + "&goods_deputy_buy_area=" + type_id;
          }
        } else {
          window.location.href = '../sign/sign.html';
        }
      }
    },
    filters: {
      h: function h(el) {
        return Math.floor(parseInt(el) / 60 / 60 % 24).toString().padStart(2, '0');
      },
      m: function m(el) {
        return Math.floor(parseInt(el) / 60 % 60).toString().padStart(2, '0');
      },
      s: function s(el) {
        return Math.floor(parseInt(el) % 60).toString().padStart(2, '0');
      }
    }
  });
  window.app = app;
})();